import React from 'react';
import { withTheme } from 'styled-components';
import { EntryEditor } from '@finect/tabular-draft-editor';
import { Check } from '@finect/tabular-icons/check';
import { Author } from '../../../Author';
import { DateLabel } from '../../../DateLabel';
import { getAnswerPath } from '../../../Questions/utils';
import { Inner, SelectedAnswerBadge, EntryBlock, PublicationDate } from './partials';
export var Answer = function Answer(_ref) {
  var theme = _ref.theme,
    answer = _ref.answer,
    question = _ref.question;
  var selected = answer.selected,
    created = answer.created,
    updated = answer.updated;
  var date = new Date(updated || created);
  var body = JSON.stringify(answer.body.metadata);
  var path = getAnswerPath(theme, question, answer);
  return React.createElement(Inner, null, React.createElement(Author, {
    withEntityCard: true,
    main: false,
    author: answer.author
  }), React.createElement(EntryBlock, {
    selected: selected
  }, selected ? React.createElement(SelectedAnswerBadge, null, React.createElement(Check, null), React.createElement("span", null, "Mejor respuesta")) : null, React.createElement(EntryEditor, {
    content: {
      type: 'blocks',
      body: body
    },
    handleDeletion: null,
    decorators: ['mentions', 'products', 'link', 'inlink', 'images'],
    readOnly: true
  })), React.createElement(PublicationDate, {
    light: true
  }, 'Publicado ', React.createElement("a", {
    href: path.url,
    title: "Ver respuesta a la pregunta ".concat(question.title)
  }, React.createElement(DateLabel, {
    noTimeTag: true,
    date: date,
    format: "timeSince"
  }))));
};
export default React.memo(withTheme(Answer));